export default __webpack_public_path__ + "static/media/slide-seven.e0c55f44.png";